
            export const sanityVisualEditingRefresh = () => new Promise((resolve) => {
  const target = window;
  const state = target.__sanityRefreshState || (target.__sanityRefreshState = { timer: null, pending: [] });

  state.pending.push(resolve);

  if (state.timer) {
    clearTimeout(state.timer);
  }

  state.timer = setTimeout(() => {
    state.timer = null;
    const pending = state.pending.splice(0);
    const settle = () => pending.forEach((done) => done());
    const refresh = target.__sanityRefresh;

    if (typeof refresh === 'function') {
      Promise.resolve(refresh()).then(settle, settle);
    } else {
      // Bridge plugin missing (e.g. visual editing not enabled for this session).
      window.location.reload();
      settle();
    }
  }, 300);
})
            export const sanityVisualEditingOnSuspiciousStega = (reports) => {
  // Accumulate onto a global rather than logging: logged lines are not reliably visible in
  // this project's DevTools, and a bare console call in this function was stripped by the
  // production minifier (verified — the body survived only in the source map). An assignment
  // is an observable side effect, so it survives, and the result is inspectable by typing
  // `window.__sanityStegaReports` in the console, where a returned value does show.
  const target = window;
  const existing = target.__sanityStegaReports || [];

  target.__sanityStegaReports = existing.concat(
    reports.map((report) => ({ kind: report.kind, attribute: report.attribute, value: report.value }))
  );
}
          